import biox from "@/brands/biox.json";
import demo from "@/brands/demo.json";

export type BrandingName = "biox" | "demo";

export interface Branding {
  portalName: string;
  companyLogo: string | null;
  productLogo: string | null;
  supportEmail: string | null;
  copyright: string;
  orderReferencePrefix: string;
  whitepaperUrl: string | null;
  partners: { name: string; logo: string; href: string }[];
  messages: typeof biox.messages;
}

const brandings: Record<BrandingName, Branding> = { biox, demo };

export function resolveBranding(value: unknown): BrandingName {
  if (value === undefined || value === null || value === "") return "demo";
  if (typeof value !== "string") {
    throw new Error("Config branding is not a string");
  }
  const name = value.trim().toLowerCase();
  if (!name) return "demo";
  if (name === "biox" || name === "demo") return name;
  throw new Error(`Config has unknown branding: ${value}`);
}

export function getBranding(name: BrandingName): Branding {
  return brandings[name];
}
